// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Button, Flex, Text } from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';
// @ts-ignore SVG imports are not supported by Typescript
import checkIcon from '../../assets/check.svg';
import Section from '../Section/Section';

export default function BrandTourism({ brand, ...rest }) {
  return (
    <React.Fragment>
      <Experiences
        title={<Trans>Wine Experiences</Trans>}
        experiences={brand.wineExperienceOfferings}
      />
      <Experiences
        title={<Trans>Hospitality</Trans>}
        experiences={brand.hospitalityOfferings}
      />
      <Experiences
        title={<Trans>Lifestyle</Trans>}
        experiences={brand.lifestyleOfferings}
      />
      <Experiences
        title={<Trans>Outdoor Experiences</Trans>}
        experiences={brand.outdoorExperienceOfferings}
      />
      <OpeningHours brand={brand} />
      <LanguagesSpoken brand={brand} />
      <Booking brand={brand} />
    </React.Fragment>
  );
}

function Experiences({ experiences, title, ...rest }) {
  if (!experiences?.length) return null;

  return (
    <Section title={title} {...rest}>
      <Flex wrap="wrap">
        {experiences.map((experience) => (
          <Experience
            key={experience}
            sx={{ width: ['100%', '50%'], marginBottom: 2 }}
          >
            {experience}
          </Experience>
        ))}
      </Flex>
    </Section>
  );
}

function Experience({ children, ...rest }) {
  return (
    <Flex align="center" {...rest}>
      <CheckIcon sx={{ marginRight: 3 }} />
      <Text>{children}</Text>
    </Flex>
  );
}

function CheckIcon(props) {
  return (
    <img
      src={checkIcon}
      alt=""
      sx={{ display: 'block', width: 16, height: 16 }}
      {...props}
    />
  );
}

function OpeningHours({ brand, ...rest }) {
  if (!brand.openingHours?.length) return null;
  return (
    <Section title={<Trans>Opening Hours</Trans>} {...rest}>
      <Text>
        {brand.openingHours.map(({ dayOfWeek, openingTime, closingTime }) => (
          <Text key={dayOfWeek}>
            {dayOfWeek}
            {(openingTime || closingTime) && (
              <React.Fragment>
                : {openingTime}–{closingTime}
              </React.Fragment>
            )}
          </Text>
        ))}
      </Text>
    </Section>
  );
}

function LanguagesSpoken({ brand, ...rest }) {
  if (!brand.languagesSpoken?.length) return null;
  return (
    <Section title={<Trans>Languages Spoken</Trans>} {...rest}>
      <Text>{brand.languagesSpoken.join(', ')}</Text>
    </Section>
  );
}

function Booking({ brand }) {
  if (!brand.bookingUrl && !brand.bookingPhone) return null;
  return (
    <Section title="">
      <Button
        variant="outline"
        href={brand.bookingUrl}
        sx={{ paddingX: 5, paddingY: 2, alignItems: 'center' }}
      >
        <Trans>Book online</Trans>
      </Button>
    </Section>
  );
}

export const fragment = graphql`
  fragment BrandTourism on Bottlebooks_AbstractBrand {
    wineExperienceOfferings
    hospitalityOfferings
    lifestyleOfferings
    outdoorExperienceOfferings
    openingHours {
      dayOfWeek(format: LOCALIZED)
      openingTime
      closingTime
    }
    languagesSpoken
    bookingUrl
  }
`;

export const BrandTourismFragment = gql`
  fragment BrandTourism on AbstractBrand {
    wineExperienceOfferings
    hospitalityOfferings
    lifestyleOfferings
    outdoorExperienceOfferings
    openingHours {
      dayOfWeek(format: LOCALIZED)
      openingTime
      closingTime
    }
    languagesSpoken
    bookingUrl
  }
`;
